/**
 * 创作者中心- 模型详情
 * @returns
 */
import { useAppDispatch } from "@/store/hooks";
import modelImg1 from "@/assets/images/creator_model_img1.png";
import modelImg2 from "@/assets/images/creator_model_img2.png";

import {
  Flex,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Box,
  Text,
  HStack,
  Divider,
  Image,
  IconButton,
  Avatar,
  Center,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Table,
  Thead,
  Tbody,
  Tfoot,
  Tr,
  Th,
  Td,
  TableCaption,
  TableContainer,
  Radio,
} from "@chakra-ui/react";
import {
  RiArrowLeftWideLine,
  RiArrowRightWideLine,
  RiBox3Line,
  RiCheckLine,
  RiCloseLine,
  RiDeleteBin4Line,
  RiDownload2Line,
  RiEditBoxLine,
  RiStarLine,
  RiThumbUpLine,
  RiUpload2Line,
  RiUploadCloud2Line,
  RiUserLine,
} from "@remixicon/react";
import { useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./modelSlick.css";
import { MyModel, MyModelDetail } from "@/types/creatorcenter";
import viplevel from "@/assets/viplevel.png";
import medal from "@/assets/medal.png";
import onekeyG from "@/assets/images/onekeygrey.svg";
import { ReactSVG } from "react-svg";
import { useSelector } from "react-redux";
import { selectUser } from "@/reducer/userslice";
import intergralIcon from "@/assets/images/icon_integral.png";
import ContentComment from "../contentdetail/contentcomment";
import { CheckIcon, CloseIcon, SmallCloseIcon } from "@chakra-ui/icons";
import { useLazyGetTrainsQuery } from "@/services/api/endpoints/model";
import { useNavigate } from "react-router-dom";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  myModel: MyModelDetail;
  // trainsList: MyModelDetail[];
  // curIndex: number;
};

const ModelDetailsModal = (props: Props) => {
  const { isOpen, onClose, myModel } = props;
  const navigate = useNavigate();
  const sliderRef = useRef<Slider>(null);
  const user = useSelector(selectUser);
  const dispatch = useAppDispatch();
  const [activeSlideIndex, setActiveSlideIndex] = useState<number>(0);

  // const currentModel = myModel.model_preview[activeSlideIndex];

  // const images = [`${modelImg1}`, `${modelImg2}`];

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    initialSlide: 0,
    // autoplay: true,
    // autoplaySpeed: 2000,
    afterChange: (current: number) => setActiveSlideIndex(current),
  };

  const handleChangeCurrentSlide = (index: number) => {
    sliderRef.current?.slickGoTo(index);
    setActiveSlideIndex(index);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="6xl" scrollBehavior="inside">
      <ModalOverlay />
      {myModel &&
        <ModalContent bg="#fff" h="100vh">
        <ModalHeader>
          <Flex justifyContent={"space-between"} alignItems="center" mr="60px">
            <HStack spacing={0}>
              <Text color="#27314D" fontSize={"18px"}>
                {/* 小清新建筑风格模型 */}
                {myModel.model_name!}
              </Text>
              <Divider orientation="vertical" h="20px" ml="20px" mr="20px" />
              <HStack spacing="10px">
                <Flex alignItems="center">
                  <RiUploadCloud2Line color="#8E94A9" size="14px" />
                  <Text color="#27314D" fontSize="10px" ml="5px">
                    2个月前
                  </Text>
                </Flex>
                <Flex alignItems="center">
                  <ReactSVG
                    src={onekeyG}
                    beforeInjection={(svg) => {
                      svg.setAttribute("style", "width: 12px");
                    }}
                  />
                  <Text color="#27314D" fontSize="10px" ml="5px">
                    11
                  </Text>
                </Flex>
                <Flex alignItems="center">
                  <RiStarLine color="#8E94A9" size="14px" />
                  <Text color="#27314D" fontSize="10px" ml="5px">
                    28
                  </Text>
                </Flex>
                <Flex alignItems="center">
                  <RiThumbUpLine color="#8E94A9" size="14px" />
                  <Text color="#27314D" fontSize="10px" ml="5px">
                    3
                  </Text>
                </Flex>
              </HStack>
            </HStack>
            {/* <Flex
              alignItems={"center"}
              bgColor="#496AE1"
              _hover={{
                bgColor: "#3F5BC1",
                color: "#E6E6E6",
              }}
              pr="2px"
            >
              <Button
                borderRadius={0}
                width={"110px"}
                height={"32px"}
                color="#FFFFFF"
                bgColor="#496AE1"
                fontWeight={"normal"}
                fontSize="12px"
                _hover={{
                  bgColor: "#3F5BC1",
                  // color: "#E6E6E6",
                }}
                leftIcon={<RiBox3Line size={"16px"} />}
                p="2px"
                position={"relative"}
              >
                应用模型
              </Button>
              {user.id !== currentModel.userid && (
                <Flex
                  h="26px"
                  bg="rgba(238, 241, 247, 0.5)"
                  gap="8px"
                  alignItems={"center"}
                  pl="5px"
                  pr="5px"
                >
                  <Text
                    color="#CBD1DF"
                    fontSize="14px"
                    textDecoration={"line-through"}
                  >
                    600
                  </Text>
                  <Text color="#FFFFFF" fontWeight={"bold"} fontSize="14px">
                    限时60
                  </Text>
                  <Image boxSize={"18px"} src={intergralIcon} />
                </Flex>
              )}
            </Flex> */}
          </Flex>
        </ModalHeader>
        <ModalCloseButton color={"#B9B9B9"} />
        <ModalBody>
          <Flex h={"100%"} gap="20px">
            {/* 左侧 */}
            <Flex flex={1} border="1px solid #DCE0EB">
              {/* 左侧列表 */}
              <Box
                w="200px"
                h="100%"
                bg="rgba(238, 241, 247, 0.5)"
                p="20px"
                boxSizing="border-box"
                overflowY={"auto"}
              >
                {myModel.model_preview && myModel.model_preview.length>0 && myModel.model_preview.map((item, index) => (
                  <Box
                    key={index}
                    borderColor={
                      activeSlideIndex === index ? "#496AE1" : "#DCE0EB"
                    }
                    borderWidth="1px"
                    p="6px"
                    boxSizing="border-box"
                    mb="20px"
                    cursor={"pointer"}
                    onClick={() => handleChangeCurrentSlide(index)}
                  >
                    <Image
                      boxSize="148px"
                      objectFit={"contain"}
                      src={item}
                      style={{ width: "100%" }}
                    />
                  </Box>
                ))}
              </Box>
              {/* 中间图 */}
              <Box flex={1} h="100%" w="0" position={"relative"}>
                <Flex w="100%" h="100%" alignItems={"center"}>
                  <Box w={"calc(100% - 80px)"} m="0 40px">
                    <Slider ref={sliderRef} {...settings}>
                      {myModel.model_preview && myModel.model_preview.length>0 && myModel.model_preview.map((item, key) => (
                        <Box key={key}>
                          <Image
                            src={item}
                            w="100%"
                            maxH={"calc(100vh - 10.5rem - 60px)"}
                            objectFit="contain"
                          />
                        </Box>
                      ))}
                    </Slider>
                  </Box>
                </Flex>
              </Box>
            </Flex>
            {/* 右侧 */}
            <Box
              w="352px"
              h="100%"
              border="1px solid #DCE0EB"
              p="12px"
              boxSizing="border-box"
              overflow={"auto"}
            >
              <Box mb="20px" p="12px" bgColor={"rgba(238, 241, 247, 0.5)"}>
                <Flex position={"relative"} alignItems={"center"}>
                  <Avatar src={`/api/v4/users/${myModel.user_id}/image`} w={"42px"} h={"42px"} />
                  <Box ml="15px" flex={1}>
                    <Flex
                      mb="5px"
                      alignItems="center"
                      justifyContent={"space-between"}
                    >
                      <HStack spacing={0}>
                        <Text fontSize={"16px"} fontWeight="bold" mr="10px">
                          {myModel.username}
                        </Text>
                        <Image mr="10px" src={viplevel} cursor="pointer" />
                        <Image mr="5px" src={medal} cursor="pointer" />
                        <Text
                          fontSize={"14px"}
                          color="#B9B9B9"
                          cursor="pointer"
                        >
                          {0}
                        </Text>
                      </HStack>
                      <Box>
                        {user.id !== myModel.user_id && (
                          <Button
                            borderRadius={"40px"}
                            width={"60px"}
                            height={"28px"}
                            color="#FFFFFF"
                            bgColor="#496AE1"
                            border={"none"}
                            fontSize="12px"
                            // colorScheme="#27314D"
                            _hover={{
                              color: "#FFFFFF",
                              bgColor: "#496AE1",
                            }}
                          >
                            关注TA
                          </Button>
                        )}
                      </Box>
                    </Flex>
                    <HStack spacing={"10px"}>
                      <Flex alignItems="center">
                        <RiUserLine size={"14px"} color="#8E94A9" />
                        <Text color="#8E94A9" fontSize="12px" ml="4px">
                          1.5K
                        </Text>
                      </Flex>
                      <Flex alignItems="center">
                        <RiUpload2Line size={"14px"} color="#8E94A9" />
                        <Text color="#8E94A9" fontSize="12px" ml="4px">
                          322
                        </Text>
                      </Flex>
                      <Flex alignItems="center">
                        <ReactSVG
                          src={onekeyG}
                          beforeInjection={(svg) => {
                            svg.setAttribute("style", "width: 12px");
                          }}
                        />
                        <Text color="#8E94A9" fontSize="12px" ml="4px">
                          191.5K
                        </Text>
                      </Flex>
                      <Flex alignItems="center">
                        <RiDownload2Line size={"14px"} color="#8E94A9" />
                        <Text color="#8E94A9" fontSize="12px" ml="4px">
                          41.5K
                        </Text>
                      </Flex>
                    </HStack>
                  </Box>
                </Flex>
              </Box>
              <Flex mb="20px" gap={"12px"}>
                {/* {user.id === currentModel.userid && (
                  <Button
                    w="96px"
                    borderRadius={0}
                    height={"40px"}
                    color="#27314D"
                    bg="rgba(238, 241, 247, 0.5)"
                    fontWeight={"normal"}
                    fontSize="14px"
                    _hover={{
                      bg: "rgba(238, 241, 247, 0.5)",
                    }}
                    leftIcon={<RiEditBoxLine size={"16px"} />}
                    p="2px"
                    position={"relative"}
                  >
                    编辑模型
                  </Button>
                )} */}
                <Button
                  borderRadius={0}
                  flex={1}
                  height={"40px"}
                  color="#FFFFFF"
                  bgColor="#496AE1"
                  fontWeight={"normal"}
                  fontSize="12px"
                  _hover={{
                    bgColor: "#3F5BC1",
                    // color: "#E6E6E6",
                  }}
                  leftIcon={<RiBox3Line size={"16px"} />}
                  p="2px"
                  position={"relative"}
                  onClick={()=> navigate("/ai/design")}
                >
                  立即生图
                </Button>
                <Button
                  flex={1}
                  borderRadius={0}
                  height={"40px"}
                  color="#27314D"
                  bg="rgba(238, 241, 247, 0.5)"
                  fontWeight={"normal"}
                  fontSize="14px"
                  _hover={{
                    bg: "rgba(238, 241, 247, 0.5)",
                  }}
                  leftIcon={<RiDownload2Line size={"16px"} />}
                  p="2px"
                  position={"relative"}
                >
                  下载(72.11MB)
                </Button>
                {/* {user.id === currentModel.userid && (
                  <Button
                    w="72px"
                    borderRadius={0}
                    height={"40px"}
                    color="#27314D"
                    bg="rgba(238, 241, 247, 0.5)"
                    fontWeight={"normal"}
                    fontSize="14px"
                    _hover={{
                      bg: "rgba(238, 241, 247, 0.5)",
                    }}
                    leftIcon={<RiDeleteBin4Line size={"16px"} />}
                    p="2px"
                    position={"relative"}
                  >
                    删除
                  </Button>
                )} */}
              </Flex>
              <Accordion
                allowToggle
                defaultIndex={[0]}
                borderColor={"#E2E8F0"}
                borderWidth="0 1px 0 1px"
                mb="20px"
              >
                <AccordionItem>
                  <h2>
                    <AccordionButton>
                      <Box
                        as="span"
                        flex="1"
                        textAlign="left"
                        color={"#27314D"}
                      >
                        模型详情
                      </Box>
                      <AccordionIcon />
                    </AccordionButton>
                  </h2>
                  <AccordionPanel p="0">
                    <TableContainer>
                      <Table borderWidth="1px 0 0 0" borderColor="#DCE0EB">
                        <Tbody>
                          <Tr fontSize="14px">
                            <Td
                              w={"100px"}
                              borderColor="gray.200"
                              borderWidth="0 1px 0 0"
                              color={"#8E94A9"}
                              p="10px"
                            >
                              模型类型
                            </Td>
                            <Td
                              p="10px"
                              whiteSpace="normal"
                              borderWidth="0"
                              color={"#27314D"}
                            >
                              {myModel.model_type}
                            </Td>
                          </Tr>
                          <Tr fontSize="14px">
                            <Td
                              borderColor="gray.200"
                              borderWidth="0 1px 0 0"
                              color={"#8E94A9"}
                              p="10px"
                            >
                              在线生成数
                            </Td>
                            <Td
                              p="10px"
                              whiteSpace="normal"
                              borderWidth="0"
                              color={"#27314D"}
                            >
                              暂无
                            </Td>
                          </Tr>
                          <Tr fontSize="14px">
                            <Td
                              borderColor="gray.200"
                              borderWidth="0 1px 0 0"
                              color={"#8E94A9"}
                              p="10px"
                            >
                              下载量
                            </Td>
                            <Td
                              borderWidth="0"
                              color={"#27314D"}
                              p="10px"
                              whiteSpace="normal"
                            >
                              暂无
                            </Td>
                          </Tr>
                          <Tr fontSize="14px">
                            <Td
                              borderColor="gray.200"
                              borderWidth="0 1px 0 0"
                              color={"#8E94A9"}
                              p="10px"
                            >
                              基础模型
                            </Td>
                            <Td
                              borderWidth="0"
                              color={"#27314D"}
                              p="10px"
                              whiteSpace="normal"
                            >
                              {myModel.base_model}
                            </Td>
                          </Tr>
                          <Tr fontSize="14px">
                            <Td
                              borderColor="gray.200"
                              borderWidth="0 1px 0 0"
                              color={"#8E94A9"}
                              p="10px"
                            >
                              功能描述
                            </Td>
                            <Td
                              p="10px"
                              whiteSpace="normal"
                              borderWidth="0"
                              color={"#27314D"}
                            >
                              {myModel.model_desc}
                            </Td>
                          </Tr>
                          
                          <Tr fontSize="14px">
                            <Td
                              borderColor="gray.200"
                              borderWidth="0 1px 0 0"
                              color={"#8E94A9"}
                              p="10px"
                            >
                              触发词
                            </Td>
                            <Td
                              borderWidth="0"
                              color={"#27314D"}
                              p="10px"
                              whiteSpace="normal"
                            >
                              {myModel.trigger_word}
                            </Td>
                          </Tr>
                        </Tbody>
                      </Table>
                    </TableContainer>
                  </AccordionPanel>
                </AccordionItem>
              </Accordion>

              <Accordion
                allowToggle
                defaultIndex={[0]}
                borderColor={"#E2E8F0"}
                borderWidth="0 1px 0 1px"
                mb="20px"
              >
                <AccordionItem>
                  <h2>
                    <AccordionButton>
                      <Box
                        as="span"
                        flex="1"
                        textAlign="left"
                        color={"#27314D"}
                      >
                        推荐参数
                      </Box>
                      <AccordionIcon />
                    </AccordionButton>
                  </h2>
                  <AccordionPanel p="0">
                    <TableContainer>
                      <Table borderWidth="1px 0 0 0" borderColor="#DCE0EB">
                        <Tbody>
                          <Tr fontSize="14px">
                            <Td
                              w={"100px"}
                              borderColor="gray.200"
                              borderWidth="0 1px 0 0"
                              color={"#8E94A9"}
                              p="10px"
                            >
                              推荐权重
                            </Td>
                            <Td
                              p="10px"
                              whiteSpace="normal"
                              borderWidth="0"
                              color={"#27314D"}
                            >
                              {myModel.weight}
                            </Td>
                          </Tr>
                          <Tr fontSize="14px">
                            <Td
                              borderColor="gray.200"
                              borderWidth="0 1px 0 0"
                              color={"#8E94A9"}
                              p="10px"
                            >
                              CFG
                            </Td>
                            <Td
                              p="10px"
                              whiteSpace="normal"
                              borderWidth="0"
                              color={"#27314D"}
                            >
                              {myModel.cfg_scale}
                            </Td>
                          </Tr>
                          <Tr fontSize="14px">
                            <Td
                              borderColor="gray.200"
                              borderWidth="0 1px 0 0"
                              color={"#8E94A9"}
                              p="10px"
                            >
                              VAE
                            </Td>
                            <Td
                              borderWidth="0"
                              color={"#27314D"}
                              p="10px"
                              whiteSpace="normal"
                            >
                              无
                            </Td>
                          </Tr>
                        </Tbody>
                      </Table>
                    </TableContainer>
                  </AccordionPanel>
                </AccordionItem>
              </Accordion>

              <Accordion
                allowToggle
                defaultIndex={[0]}
                borderColor={"#E2E8F0"}
                borderWidth="0 1px 0 1px"
                mb="20px"
              >
                <AccordionItem>
                  <h2>
                    <AccordionButton>
                      <Box
                        as="span"
                        flex="1"
                        textAlign="left"
                        color={"#27314D"}
                      >
                        许可范围
                      </Box>
                      <AccordionIcon />
                    </AccordionButton>
                  </h2>
                  <AccordionPanel p="0">
                    <TableContainer>
                      <Table borderWidth="1px 0 0 0" borderColor="#DCE0EB">
                        <Tbody>
                          <Tr fontSize="14px">
                            <Td
                              w={"100px"}
                              borderColor="gray.200"
                              borderWidth="0 1px 0 0"
                              color={"#8E94A9"}
                              p="10px"
                              valign="top"
                            >
                              创作许可范围
                            </Td>
                            <Td
                              p="10px"
                              whiteSpace="normal"
                              borderWidth="0"
                              color={"#27314D"}
                            >
                              <Flex flexWrap={"wrap"} gap="10px">
                                <HStack spacing={"2px"}><RiCheckLine color={"#09C38B"} size="16px"/><Text>可在线生图</Text></HStack>
                                <HStack spacing={"2px"}><RiCheckLine color={"#09C38B"} size="16px"/><Text>可下载</Text></HStack>
                                <HStack spacing={"2px"}><RiCloseLine color={"#FE5290"} size="16px" /><Text>不可进行融合</Text></HStack>
                              </Flex>
                            </Td>
                          </Tr>
                          <Tr fontSize="14px">
                            <Td
                              borderColor="gray.200"
                              borderWidth="0 1px 0 0"
                              color={"#8E94A9"}
                              p="10px"
                              valign="top"
                            >
                              商业许可范围
                            </Td>
                            <Td
                              p="10px"
                              whiteSpace="normal"
                              borderWidth="0"
                              color={"#27314D"}
                            >
                              <Flex flexWrap={"wrap"} gap="10px">
                                <HStack spacing={"2px"} ><RiCheckLine color={"#09C38B"} size="16px"/><Text>仅会员可出售生成图片或用于商业目的</Text></HStack>
                                <HStack spacing={"2px"}><RiCloseLine color={"#FE5290"} size="16px" /><Text>不可转售模型或出售融合模型</Text></HStack>
                              </Flex>
                            </Td>
                          </Tr>
                        </Tbody>
                      </Table>
                    </TableContainer>
                  </AccordionPanel>
                </AccordionItem>
              </Accordion>

              {/* {user.id === currentModel.userid && (
                <Accordion
                  allowToggle
                  defaultIndex={[0]}
                  borderColor={"#E2E8F0"}
                  borderWidth="0 1px 0 1px"
                  mb="20px"
                >
                  <AccordionItem>
                    <h2>
                      <AccordionButton>
                        <Box
                          as="span"
                          flex="1"
                          textAlign="left"
                          color={"#27314D"}
                        >
                          模型权限
                        </Box>
                        <AccordionIcon />
                      </AccordionButton>
                    </h2>
                    <AccordionPanel p="0">
                      <TableContainer>
                        <Table borderWidth="1px 0 0 0" borderColor="#DCE0EB">
                          <Tbody>
                            <Tr fontSize="14px">
                              <Td borderWidth="0" color={"#8E94A9"} p="10px">
                                模型权限
                              </Td>
                              <Td
                                p="10px"
                                whiteSpace="normal"
                                borderWidth="0"
                                color={"#27314D"}
                              >
                                <Radio value="" mb="10px">
                                  <Text color={"#27314D"} fontSize="14px">
                                    所有人可以使用我的模型进行灵感创作
                                  </Text>
                                </Radio>
                                <Radio value="">
                                  <Text color={"#27314D"} fontSize="14px">
                                    所有人可以下载我的模型
                                  </Text>
                                </Radio>
                              </Td>
                            </Tr>
                            <Tr fontSize="14px">
                              <Td borderWidth=" 0" color={"#8E94A9"} p="10px">
                                模型价格
                              </Td>
                              <Td
                                p="10px"
                                whiteSpace="normal"
                                borderWidth="0"
                                color={"#27314D"}
                              >
                                <Flex
                                  w={"120px"}
                                  h="32px"
                                  bg="rgba(238, 241, 247, 0.5)"
                                  gap="8px"
                                  alignItems={"center"}
                                  justifyContent="center"
                                >
                                  <Text
                                    color="#CBD1DF"
                                    fontSize="14px"
                                    textDecoration={"line-through"}
                                  >
                                    600
                                  </Text>
                                  <Text
                                    color="#27314D"
                                    fontWeight={"bold"}
                                    fontSize="14px"
                                  >
                                    限时60
                                  </Text>
                                  <Image boxSize={"18px"} src={intergralIcon} />
                                </Flex>
                              </Td>
                            </Tr>
                          </Tbody>
                        </Table>
                      </TableContainer>
                    </AccordionPanel>
                  </AccordionItem>
                </Accordion>
              )} */}

              {/* <Accordion
                allowToggle
                defaultIndex={[0]}
                borderColor={"#E2E8F0"}
                borderWidth="0 1px 0 1px"
              >
                <AccordionItem>
                  <h2>
                    <AccordionButton>
                      <Box
                        as="span"
                        flex="1"
                        textAlign="left"
                        color={"#27314D"}
                      >
                        评论（3）
                      </Box>
                      <AccordionIcon />
                    </AccordionButton>
                  </h2>
                  <AccordionPanel p="0">
                    <Box
                      borderWidth="1px 0 0 0"
                      borderColor="#DCE0EB"
                      p="20px 10px"
                    >
                      <ContentComment contentId={""} />
                    </Box>
                  </AccordionPanel>
                </AccordionItem>
              </Accordion> */}
            </Box>
          </Flex>
        </ModalBody>
      </ModalContent>
      }
      
    </Modal>
  );
};

export default ModelDetailsModal;